import { HistoryActivityActionEnum } from "Data/interfaces/History/IHistoryActivityApi";
import { activitiesContentOptions } from "./ActivityOptions";
import { HistoryActivityActionDescriptionRecord, HistoryActivityIconRecord } from "Data/interfaces/History/IHistoryActivityRecord";

const contentActivityIcon: HistoryActivityIconRecord = {
  [HistoryActivityActionEnum.TopicCreated]: { icon: 'activities' },
  [HistoryActivityActionEnum.TopicStatusUpdated]: { icon: 'trocarStatus' },
  [HistoryActivityActionEnum.TopicUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicTitleUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicCommunicationTypeUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicDescriptionUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicAssignedUsersUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicDisciplinesUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicDueDateUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicVisibilityUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicPriorityUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicLocationUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicAttachmentAdded]: { icon: 'paperclip' },
  [HistoryActivityActionEnum.TopicAttachmentDeleted]: { icon: 'paperclip' },
  [HistoryActivityActionEnum.TopicStageUpdated]: { icon: 'editar' },
}
const actionActivityDescription: HistoryActivityActionDescriptionRecord = {
  [HistoryActivityActionEnum.TopicCreated]: 'criou a atividade.',
  [HistoryActivityActionEnum.TopicStatusUpdated]: 'alterou o Status',
  [HistoryActivityActionEnum.TopicTitleUpdated]: 'editou o Resumo',
  [HistoryActivityActionEnum.TopicCommunicationTypeUpdated]: 'alterou o Meio',
  [HistoryActivityActionEnum.TopicDescriptionUpdated]: 'editou a Observação',
  [HistoryActivityActionEnum.TopicAssignedUsersUpdated]: 'alterou os Responsáveis',
  [HistoryActivityActionEnum.TopicDisciplinesUpdated]: 'alterou as Disciplinas',
  [HistoryActivityActionEnum.TopicDueDateUpdated]: 'alterou o Prazo',
  [HistoryActivityActionEnum.TopicVisibilityUpdated]: 'alterou a Visibilidade',
  [HistoryActivityActionEnum.TopicPriorityUpdated]: 'alterou a Prioridade',
  [HistoryActivityActionEnum.TopicLocationUpdated]: 'alterou o Local',
  [HistoryActivityActionEnum.TopicAttachmentAdded]: 'adicionou um anexo',
  [HistoryActivityActionEnum.TopicAttachmentDeleted]: 'removeu um anexo',
  [HistoryActivityActionEnum.TopicStageUpdated]: 'alterou a Etapa',
}

export {
  activitiesContentOptions,
  contentActivityIcon,
  actionActivityDescription,
};
